import axios from "axios";
import { API_BASE_URL } from "./Configuration";

axios.defaults.withCredentials = true;

export const SESSION_EXPIRED_EVENT = "auth:session-expired";

let isRefreshing = false;
let pendingRequests = [];

const flushQueue = (shouldRetry) => {
  pendingRequests.forEach((resolveOrReject) => resolveOrReject(shouldRetry));
  pendingRequests = [];
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;

    if (!response || response.status !== 401 || !config) {
      return Promise.reject(error);
    }

    const isTokenRefreshEndpoint = config.url.includes("/token/refresh/");
    const isLoginEndpoint =
      config.url.includes("/users/token/") && !isTokenRefreshEndpoint;

    if (isTokenRefreshEndpoint || isLoginEndpoint || config._retry) {
      return Promise.reject(error);
    }

    config._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingRequests.push((shouldRetry) =>
          shouldRetry ? resolve(axios(config)) : reject(error)
        );
      });
    }

    isRefreshing = true;

    return axios
      .post(`${API_BASE_URL}/users/token/refresh/`, {}, { withCredentials: true })
      .then((refreshResponse) => {
        isRefreshing = false;
        flushQueue(true);
        if (refreshResponse.status === 200) {
          return axios(config);
        }
        return Promise.reject(error);
      })
      .catch((refreshError) => {
        isRefreshing = false;
        flushQueue(false);
        console.error("Token refresh failed:", refreshError);
        // A hard redirect here would reload into the /users/me/ check and loop forever.
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
        return Promise.reject(error);
      });
  }
);